import React, { useState, useEffect } from 'react';
import HannyaMessages from './HannyaMessages';
import api from '../services/api';
import './HannyaDashboard.css';

function HannyaDashboard({ onLogout }) {
  const [activeTab, setActiveTab] = useState('messages');
  const [unreadCount, setUnreadCount] = useState(0);
  const token = localStorage.getItem('hannyaToken');

  useEffect(() => {
    loadUnreadCount();
  }, []);

  const loadUnreadCount = async () => {
    try {
      const messages = await api.getMessages(token);
      if (Array.isArray(messages)) {
        const unread = messages.filter(m => !m.lido).length;
        setUnreadCount(unread);
      }
    } catch (error) {
      console.error('Erro ao carregar contagem:', error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('hannyaAuth');
    localStorage.removeItem('hannyaToken');
    localStorage.removeItem('hannyaUser');
    onLogout();
  };

  return (
    <div className="hannya-dashboard">
      {/* Sidebar */}
      <aside className="hannya-sidebar">
        <div className="hannya-sidebar-logo">Survows</div>
        <nav className="hannya-sidebar-nav">
          <button
            className={`hannya-nav-item ${activeTab === 'messages' ? 'active' : ''}`}
            onClick={() => setActiveTab('messages')}
          >
            <i className="fas fa-envelope"></i>
            <span>Mensagens</span>
            {unreadCount > 0 && (
              <span className="badge-count">{unreadCount}</span>
            )}
          </button>
          <button
            className={`hannya-nav-item ${activeTab === 'analytics' ? 'active' : ''}`}
            onClick={() => setActiveTab('analytics')}
          >
            <i className="fas fa-chart-line"></i>
            <span>Analytics</span>
          </button>
          <button
            className={`hannya-nav-item ${activeTab === 'settings' ? 'active' : ''}`}
            onClick={() => setActiveTab('settings')}
          >
            <i className="fas fa-cog"></i>
            <span>Configurações</span>
          </button>
        </nav>
        <button className="hannya-logout-btn" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt"></i>
          <span>Sair</span>
        </button>
      </aside>

      {/* Main Content */}
      <main className="hannya-main">
        <header className="hannya-main-header">
          <div className="hannya-header-title">
            <h1>Painel de Controle</h1>
            <p>Gerencie as informações do seu site</p>
          </div>
          <div className="hannya-header-user">
            <div className="hannya-user-info">
              <i className="fas fa-user-shield"></i>
              <span>Administrador</span>
            </div>
          </div>
        </header>

        <div className="hannya-content">
          {activeTab === 'messages' && <HannyaMessages />}
          {activeTab === 'analytics' && (
            <div className="hannya-placeholder">
              <i className="fas fa-chart-pie"></i>
              <h3>Analytics em breve</h3>
              <p>Estatísticas de acesso e conversões</p>
            </div>
          )}
          {activeTab === 'settings' && (
            <div className="hannya-placeholder">
              <i className="fas fa-cogs"></i>
              <h3>Configurações em breve</h3>
              <p>Personalize as configurações do sistema</p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default HannyaDashboard;
